import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/tariffs/tariff.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { useEmspBoTariffListContext } from '@app/feature/emsp-bo-tariff/emsp-bo-tariff.context';

export interface EmspBoTariffListIdCellProps
  extends CellContext<TariffModel, TariffModel['id']> {}

export const EmspBoTariffListIdCell = (
  props: EmspBoTariffListIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue, row } = props;
  const navigate = useNavigate();
  const { getPaginatedQueryParameters } = useEmspBoTariffListContext();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() => {
        const path = generatePath(APP_PATH.EMSP_BO_TARIFF.DETAILS, {
          id: row.original.id,
        });
        navigate(`${path}?cpoId=${getPaginatedQueryParameters.cpoId}`);
      }}
      fullWidth>
      <Text truncate>{getValue()}</Text>
    </Link>
  );
};
